import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a968be4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup__wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "popup__close"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#close" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "popup__top" }
const _hoisted_6 = {
  key: 0,
  alt: ""
}
const _hoisted_7 = { class: "popup__decline" }
const _hoisted_8 = { class: "popup__bottom" }
const _hoisted_9 = { class: "popup__btn" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "popup__wrapper c-p-w"
}
const _hoisted_12 = {
  key: 0,
  class: "popup__close"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#close" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "popup__top c-p-t" }
const _hoisted_16 = { class: "popup__decline" }
const _hoisted_17 = { class: "popup__bottom c-p-b" }
const _hoisted_18 = { class: "row form__field" }
const _hoisted_19 = {
  class: "form__label",
  for: `username`
}
const _hoisted_20 = { class: "row form__field" }
const _hoisted_21 = {
  class: "form__label",
  for: `password`
}
const _hoisted_22 = {
  class: "form__pass",
  type: "button"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#eye-off" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "form__link" }
const _hoisted_26 = { class: "form__btn" }
const _hoisted_27 = {
  class: "button",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.model.show,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.show) = $event)),
    modal: true,
    dismissableMask: _ctx.model.closeOnOutsideClick,
    showHeader: false,
    breakpoints: { '400px': '90vw' },
    contentStyle: "overflow: overlay; padding: 0px; background-color: transparent;",
    style: {"width":"440px"}
  }, {
    default: _withCtx(() => [
      (_ctx.model.show && !_ctx.model.isLoginPopupOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.model.showCloseButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("button", {
                    class: "dashboard__popup-closeBtn",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = () => (_ctx.model.show = false))
                  }, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.model.type === 'warning')
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.model.message), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.buttons, (button, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    class: _normalizeClass(["button", _ctx.getButtonClass(button)]),
                    type: "button",
                    onClick: ($event: any) => (_ctx.doButtonAction(button))
                  }, _toDisplayString(button.title), 11, _hoisted_10))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.model.show && _ctx.model.isLoginPopupOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_ctx.model.showCloseButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "dashboard__popup-closeBtn",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
                        () => {
                            _ctx.model.show = false;
                            _ctx.model.isLoginPopupOpen = false;
                        }
                    )
                  }, _hoisted_14)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.i18n.t("authRequiredPopup.message")), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("form", {
                class: "login__form",
                onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.login.onSubmit && _ctx.login.onSubmit(...args))),
                action: "#"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["col form__col", { 'form__group--active': _ctx.login.username }])
                  }, [
                    _createVNode(_component_base_input, {
                      class: _normalizeClass(["form__input", { '--error': _ctx.login.usernameError }]),
                      type: "text",
                      modelValue: _ctx.login.username,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.login.username) = $event)),
                      id: "username",
                      name: "username"
                    }, null, 8, ["class", "modelValue"]),
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.i18n.t("auth.login")), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["col form__col", { 'form__group--active': _ctx.login.password }])
                  }, [
                    _createVNode(_component_base_input, {
                      class: _normalizeClass(["form__input", { '--error': _ctx.login.passwordError }]),
                      type: "password",
                      modelValue: _ctx.login.password,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.login.password) = $event)),
                      ref: "passwordInput",
                      id: "password",
                      name: "password"
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.i18n.t("auth.password")), 1),
                    _createElementVNode("button", _hoisted_22, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.togglePassword())),
                        class: "sprite-icon form__eye",
                        width: "18",
                        height: "18"
                      }, _hoisted_24))
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.signUpURL)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "form__fpass p-mr-3",
                        to: _ctx.signUpURL,
                        onClick: _cache[5] || (_cache[5] = 
                                () => {
                                    _ctx.model.show = false;
                                    _ctx.model.isLoginPopupOpen = false;
                                }
                            )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.i18n.t("authRequiredPopup.signUp")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_link, {
                    class: "form__fpass",
                    to: "/forgot-password",
                    onClick: _cache[6] || (_cache[6] = 
                                () => {
                                    _ctx.model.show = false;
                                    _ctx.model.isLoginPopupOpen = false;
                                }
                            )
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t("auth.forgotPassword")) + "? ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", _hoisted_27, _toDisplayString(_ctx.i18n.t("auth.signIn")), 1)
                ])
              ], 32)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "dismissableMask"]))
}